export enum RiskAssessmentResultTestIds {
  Assessment = 'assessment',
  ComplianceMonitoringAssessment = 'complianceMonitoringAssessment',
  ControlType = 'controlType',
  Impact = 'impact',
  InternalAuditReport = 'internalAuditReport',
  Likelihood = 'likelihood',
  Rating = 'rating',
  Risk = 'risk',
  TestDate = 'resultDate',
}
